import { ProductSizeType } from '@epicuro-next/state/config-strip-state';
import { Unpacked } from '@epicuro-next/utilities';
import { OrderType, Product } from 'graphql-api/gql-api-interfaces';

const trueDemandInventoryId = 'TRUEDEMAND';

// use for adding true demand inventory mock data while debugging
export const extendWithTrueDemandInventory = (product: Product): Product => {
  if (!product.children) return product;

  const trueDemandInventory = (
    sizeId: string,
    availableFromDateUtc: string,
  ): NonNullable<Unpacked<NonNullable<ProductSizeType>['inventoryItems']>> => {
    const itemId = `${sizeId}-${trueDemandInventoryId}`;
    return {
      inventoryId: trueDemandInventoryId,
      inventoryExternalId: trueDemandInventoryId,
      itemId,
      quantity: null,
      isNotConsumable: false,
      orderType: OrderType.Now,
      availableFromDateUtc,
      availableToDateUtc: '9999-12-31T23:59:59.9999999Z',
    };
  };

  return {
    ...product,
    children: product.children.map((variant) => {
      if (!variant.children) return variant;

      return {
        ...variant,
        children: variant.children.map((size) => {
          const hasNowInventory = size.inventoryItems?.find(
            (i) => i.orderType === OrderType.Now,
          );

          if (!hasNowInventory) return size;

          return {
            ...size,
            inventoryItems: (size.inventoryItems ?? []).concat(
              trueDemandInventory(
                size.productId,
                hasNowInventory.availableFromDateUtc,
              ),
            ),
          };
        }),
      };
    }),
  };
};

export const isTrueDemandInventory = (itemId = '') =>
  itemId.includes(trueDemandInventoryId);
